export default "__VITE_ASSET__5d75afa8__"